import styled from 'styled-components';

export const RecordingTextWrapper = styled.div`
  position: absolute;
  top: -31px;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;
